function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "System-Admin",
  transform: "translate(-810.000000, -522.000000)",
  fill: "#000000",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-14",
  transform: "translate(814.000000, 519.500000) rotate(-90.000000) translate(-814.000000, -519.500000) translate(800.500000, 515.500000)"
}, React.createElement("path", {
  d: "M0.649960537,4.29351926 L5.40660353,7.45196166 C5.63812155,7.60927872 5.91173375,7.35515117 5.82754538,7.05261837 L5.37503289,5.4552452 L10.2053407,5.4552452 C10.3631939,5.4552452 10.5,5.31002946 10.5,5.11640847 L10.5,2.87766576 C10.5,2.69614608 10.3737174,2.53882903 10.2053407,2.53882903 L5.37503289,2.53882903 L5.82754538,0.941455858 C5.91173375,0.651024373 5.63812155,0.396896823 5.40660353,0.542112565 L0.649960537,3.71265628 C0.450013154,3.84577072 0.450013154,4.16040483 0.649960537,4.29351926 Z",
  id: "Path"
}))));

const SvgDownMove = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "8px",
    height: "11px",
    viewBox: "0 0 8 11",
    ref: svgRef
  }, props), _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgDownMove, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/down-move.07b34560.svg";
export { ForwardRef as ReactComponent };